import { PaymentMessage } from 'src/devices/payment/dtos/eps-data';
import { showEftInfo } from './show-eft-info';
import { convertCurrency } from '../../common/helpers/currency-helper';
import { showNotification } from './show-notification';

export const processPartialTender = async (
  purchaseResponse: PaymentMessage,
  isEBTCard: boolean,
): Promise<void> => {
  if (
    purchaseResponse?.amounts?.amountTendered &&
    purchaseResponse?.amounts?.amountApproved &&
    purchaseResponse.amounts.amountApproved < purchaseResponse.amounts.amountTendered
  ) {
    if (isEBTCard) {
      return showEftInfo('EPS_SoftDeclineCaption', 'EPS_SoftDeclineSubmessage', 'Ok', 'Cancel', {
        arg: convertCurrency(Number(purchaseResponse.amounts.amountApproved)),
      });
    } else {
      return showNotification(
        'EPS_Partial_Authorization',
        'EPS_Partial_AuthorizationDetails',
        undefined,
        undefined,
        {
          arg: convertCurrency(Number(purchaseResponse.amounts.amountApproved)),
          arg2: convertCurrency(Number(purchaseResponse.amounts.amountTendered)),
        },
      );
    }
  }
};
